import type { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { APP_CONFIG } from '@core/config/app-config.tokens';
import { MachineInfoService } from '@core/machine/machine-info.service';
import type { Observable } from 'rxjs';
import { from, switchMap } from 'rxjs';

export const machineInfoInterceptor: HttpInterceptorFn = (
  request,
  next,
): Observable<HttpEvent<unknown>> => {
  const appConfig = inject(APP_CONFIG);
  const machineInfoService = inject(MachineInfoService);

  const isEnabled = appConfig.featureFlags['machinePlugin'];

  const sendRequest = (finalReq = request) => next(finalReq);

  if (!isEnabled || request.method.toUpperCase() === 'GET') {
    return sendRequest();
  }

  return from(machineInfoService.getMachineInfo()).pipe(
    switchMap((info) => {
      const updatedHeaders = request.headers
        .set('X-IP', info.ip)
        .set('X-MAC-Address', info.mac)
        .set('X-CPU-ID', info.cpuId);

      const newReq = request.clone({ headers: updatedHeaders });
      return sendRequest(newReq);
    }),
  );
};
